<template>
  <div class="scroll">
    <div class="scroll-indicator">
      <div class="scroll-indicator__highlight" />
    </div>
    <p>Scroll</p>
  </div>
</template>

<script>
import { gsap } from 'gsap'
export default {
  mounted () {
    const timeline = gsap.timeline({
      delay: 0.5,
      repeat: -1,
      repeatDelay: 2
    })
    timeline.fromTo('.scroll-indicator__highlight', {
      y: -100
    }, {
      duration: 3,
      y: 200
    })
  }
}
</script>

<style lang="scss">
@import '../../../assets/styles/_variables';
@import "../../../assets/styles/breakpoints";
.scroll {
  .scroll-indicator {
    width: 1px;
    height: 120px;
    background-color: $gold;
    overflow: hidden;
    .scroll-indicator__highlight {
      position: relative;
      width: 1px;
      height: 40px;
      background: $indigo;
      &:before {
        position: absolute;
        top: -20px;
        content: '';
        width: 1px;
        height: 20px;
        background: linear-gradient(0deg, $indigo 0%, rgba(0,0,0,0) 100%);
      }
      &:after {
        position: absolute;
        bottom: -20px;
        content: '';
        width: 1px;
        height: 20px;
        background: linear-gradient(180deg, $indigo 0%, rgba(0,0,0,0) 100%);
      }
    }
  }
  p {
    position: absolute;
    padding: 5px 0;
    bottom: 25%;
    left: -50%;
    transform: translateX(-50%);
    background-color: $white;
    color: $sage;
    font-weight: 100;
    font-style: italic;
    @include breakpoint(sm) {
      font-size: 1rem;
    }
  }
}
</style>
